import { RootfiDataModelsPrefix } from '@commenda/types/src/root-fi/types';
import { enumKeyToDisplayName } from '@commenda/utils';

/** Human-readable label for a RootFi v4 data model enum value. */
export function formatRootFiDataModelName(dataModel: string): string {
  let formattedName = dataModel;
  Object.values(RootfiDataModelsPrefix).forEach((prefix) => {
    formattedName = formattedName.replaceAll(prefix, '');
  });
  return enumKeyToDisplayName(formattedName);
}
